import { useRef, useState } from "react";
import { DailyCheckinContext } from ".";
import { ErrorBoundary2 } from "@/pages/ErrorBoundary2";
import { Rating } from "@/components/Checkin";

type DailyCheckinProviderProps = { children: React.ReactNode };
export function DailyCheckinProvider({ children }: DailyCheckinProviderProps) {
    const [morningRatings, setMorningRatings] = useState<Rating[] | null>(null);
    const [eveningRatings, setEveningRatings] = useState<Rating[] | null>(null);
    const [isMorningCheckinOpen, setMorningCheckinOpen] = useState(false);
    const [isEveningCheckinOpen, setEveningCheckinOpen] = useState(false);
    const morningRef = useRef(null);
    const eveningRef = useRef(null);

    return (
        <DailyCheckinContext.Provider value={{
            morning: {
                isOpen: isMorningCheckinOpen,
                setOpen: setMorningCheckinOpen,
                ref: morningRef,
                ratings: morningRatings,
                setRatings: setMorningRatings,
            },
            evening: {
                isOpen: isEveningCheckinOpen,
                setOpen: setEveningCheckinOpen,
                ref: eveningRef,
                ratings: eveningRatings,
                setRatings: setEveningRatings,

            }
        }}>
            <ErrorBoundary2 msg="DailyCheckinContext Inner">
                {children}
            </ErrorBoundary2>
        </DailyCheckinContext.Provider>
    );
}